/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Explorer_Display_New_Folder_TitleInputs */

const en_explorer_display_new_folder_title = /** @type {(inputs: Explorer_Display_New_Folder_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`New Folder`)
};

const fr_explorer_display_new_folder_title = /** @type {(inputs: Explorer_Display_New_Folder_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nouveau dossier`)
};

const de_explorer_display_new_folder_title = /** @type {(inputs: Explorer_Display_New_Folder_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Neuer Ordner`)
};

const it_explorer_display_new_folder_title = /** @type {(inputs: Explorer_Display_New_Folder_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nuova cartella`)
};

const ru_explorer_display_new_folder_title = /** @type {(inputs: Explorer_Display_New_Folder_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Новая папка`)
};

const es_explorer_display_new_folder_title = /** @type {(inputs: Explorer_Display_New_Folder_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nueva carpeta`)
};

const zh_cn2_explorer_display_new_folder_title = /** @type {(inputs: Explorer_Display_New_Folder_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`新建文件夹`)
};

const ja_explorer_display_new_folder_title = /** @type {(inputs: Explorer_Display_New_Folder_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`新しいフォルダ`)
};

const hi_explorer_display_new_folder_title = /** @type {(inputs: Explorer_Display_New_Folder_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`नया फ़ोल्डर`)
};

const pt_pt2_explorer_display_new_folder_title = /** @type {(inputs: Explorer_Display_New_Folder_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nova pasta`)
};

/**
* | output |
* | --- |
* | "New Folder" |
*
* @param {Explorer_Display_New_Folder_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const explorer_display_new_folder_title = /** @type {((inputs?: Explorer_Display_New_Folder_TitleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Explorer_Display_New_Folder_TitleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_explorer_display_new_folder_title(inputs)
	if (locale === "de") return de_explorer_display_new_folder_title(inputs)
	if (locale === "it") return it_explorer_display_new_folder_title(inputs)
	if (locale === "ru") return ru_explorer_display_new_folder_title(inputs)
	if (locale === "es") return es_explorer_display_new_folder_title(inputs)
	if (locale === "zh-CN") return zh_cn2_explorer_display_new_folder_title(inputs)
	if (locale === "ja") return ja_explorer_display_new_folder_title(inputs)
	if (locale === "hi") return hi_explorer_display_new_folder_title(inputs)
	if (locale === "pt-PT") return pt_pt2_explorer_display_new_folder_title(inputs)
	return en_explorer_display_new_folder_title(inputs)
});